import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useAppDispatch } from '../store';
import { logoutAction } from '../actions/authActions';
import { clearTokens } from '../helpers/tokenStore';
import { setSessionLostHandler } from '../helpers/authFailure';

/**
 * DEV-101 §24.3: сессия кончилась - уводим на вход, а не оставляем на пустом экране.
 *
 * Слой запросов про роутер и стор не знает и знать не должен, поэтому он зовёт
 * зарегистрированный здесь обработчик. Компонент ничего не рисует, он живёт внутри
 * роутера ради `useNavigate`.
 *
 * Раньше отказ по сессии доезжал до компонента обычным ответом: список полисов молча
 * оставался пустым, человек видел кабинет без единого полиса и не понимал, что его
 * просто разлогинило.
 */
const SessionGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setSessionLostHandler(() => {
      clearTokens();
      dispatch(logoutAction());
      // На самой форме входа никуда не уводим: иначе запрос, который там же и падает,
      // гоняет по кругу.
      if (!location.pathname.startsWith('/login')) {
        navigate('/login', { replace: true });
      }
    });

    return () => setSessionLostHandler(null);
  }, [navigate, location.pathname, dispatch]);

  return null;
};

export default SessionGuard;
